import { render } from "./Popup.vue?vue&type=template&id=59b9e1db"
import script from "./Popup.vue?vue&type=script&lang=js"
export * from "./Popup.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/bezbedno/admin/static/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"js/Components/Popup.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "59b9e1db"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('59b9e1db', __exports__)) {
    console.log('reload')
    api.reload('59b9e1db', __exports__)
  }
  
  module.hot.accept("./Popup.vue?vue&type=template&id=59b9e1db", () => {
    console.log('re-render')
    api.rerender('59b9e1db', render)
  })

}


export default __exports__